export const RECOGNITION_OF_PRIOR_LEARNING_IFRAME_SRC =
  'https://ams.woolf.university/rpl-for-credit/invite/CB7TgGMwOKKnadw_4ZH_1sj6WvmSGnqdVkWsUIbjl1g';

export const RECOGNITION_OF_PRIOR_LEARNING_PATH = '/recognition-of-prior-learning';

export const RPL_LP_SECTION_ID = 'recognition-of-prior-learning';

export const RPL_WOOLF_FAQ_HREF = 'https://help.woolf.education/article/recognition-of-prior-learning-rpl-fa-qs';

export const RPL_MASTERS_PATH = '/masters-artificial-intelligence';

export const RPL_ANALYTICS_LABEL = {
  checkEligibility: 'rpl_check_eligibility',
  learnMore: 'rpl_learn_more',
  exploreMasters: 'rpl_explore_masters',
} as const;

export const RPL_EYEBROW = 'Recognition of prior learning';

export const RPL_CALCULATE_CTA = 'Calculate your exemption';

export const RPL_BODY = 'Your work and learning experience already counts. Complete a short form to find out how much.';

export const RPL_HEADLINE = {
  masters: "Get up to 30% of your Master's exempted with prior experience",
  mba: 'Get up to 30% of your MBA exempted with prior experience',
} as const;

export const RPL_PROMO_HEADLINE = "Want a Master's in AI, but don't have time?";

export const RPL_PROMO_BODY = "Get up to 30% of your Master's exempted with prior experience.";

export const RPL_EXPLORE_MASTERS_LABEL = "Explore the Master's in AI";

export type RplQuote = {
  name: string;
  role: string;
  quote: string;
  imageSrc: string;
};

export const RPL_LP_QUOTES: RplQuote[] = [
  {
    name: 'Stanley Ze Ya',
    role: 'MSc in AI Student | Director/Principal Product Owner; CORe + HBS credentials',
    quote:
      'Receiving the credit exemptions was a significant advantage and a huge motivation for me. It allowed me to bypass foundational topics I had already mastered through years of practice, enabling me to dive straight into the more advanced, specialized AI modules.',
    imageSrc: '/images/recognition-of-prior-learning/stanley-ze-ya-cutout.webp',
  },
  {
    name: 'Luis Muniz',
    role: 'MSc in AI Student | Business Owner, Tech Consulting',
    quote:
      'The process was straightforward and practical. It recognized prior learning I had completed outside of the graduate-level program. The exemption helped make the degree more manageable alongside running my business and serving clients, by allowing me to focus more of my limited study time on the courses that added the most new value.',
    imageSrc: '/images/recognition-of-prior-learning/luis-muniz.webp',
  },
];

export const RPL_COMPACT_QUOTES: RplQuote[] = [
  {
    name: 'Stanley Ze Ya',
    role: 'MSc in AI Student | Director/Principal Product Owner',
    quote:
      'Receiving the credit exemptions was a significant advantage. I bypassed what I had already mastered and went straight into specialized AI modules.',
    imageSrc: '/images/recognition-of-prior-learning/stanley-ze-ya-cutout.webp',
  },
  {
    name: 'Luis Muniz',
    role: 'MSc in AI Student | Business Owner, Tech Consulting',
    quote:
      'The process was straightforward. It recognized prior learning, so I could focus limited study time on the courses that added the most new value.',
    imageSrc: '/images/recognition-of-prior-learning/luis-muniz.webp',
  },
];
